import { Params, useParams as useRouteParams } from 'react-router-dom';
import { useScopedParams } from '../context/ParamsProvider';
import { useEffect, useMemo } from 'react';

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type DefaultAdaptableParams = {
  // Encoded group id
  groupId?: string;
  // Merchandise id == group id
  merchandiseId?: string;
  // Encoded device id
  deviceId?: string;
  controlUnitId?: string;
};
export const useAdaptableParams = <
  ParamsOrKey extends string | Record<string, string | undefined> = string
>(): Readonly<Params<string>> => {
  const contextParams = useScopedParams();
  const routeParams = useRouteParams();

  const memoParams = useMemo(
    () => (Object.keys(contextParams).length > 0 ? contextParams : routeParams),
    [
      routeParams.deviceId,
      routeParams.groupId,
      routeParams.controlUnitId,
      routeParams.merchandiseId,
      contextParams.deviceId,
      contextParams.groupId,
      contextParams.controlUnitId,
      contextParams.merchandiseId,
    ]
  );
  return memoParams;
};
